import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/circle-calculator',
  component: () => import('../../routes/CircleCalculator.svelte'),
  card: {
    id: 'circle-calculator',
    title: 'Circle Calculator',
    description: 'Calculate the radius, diameter, circumference, and area of a circle from any known value. Also includes sphere surface area and volume.',
    icon: 'circle',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/circle-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Circle Calculator – Find Radius, Diameter, Circumference & Area',
    description: 'Free circle calculator. Enter any circle measurement — radius, diameter, circumference, or area — and instantly get all other values plus sphere surface area and volume.',
  },
};

export default meta;
